// extracted by mini-css-extract-plugin
module.exports = {"competitionSection":"CompetitionSection_competitionSection__fRMBH"};